import React from 'react';
import { Star, Quote } from 'lucide-react';
import { motion } from 'framer-motion';
const reviews = [{
  id: 1,
  text: "Best suspension kit I've ever installed. The ride quality improvement is night and day. Pro One customer service was incredible.",
  author: 'Mike R.',
  vehicle: '2019 Ford F-150'
}, {
  id: 2,
  text: 'Ordered a leveling kit and it arrived in 2 days. Perfect fit, great instructions. Will definitely buy from Pro One Design again.',
  author: 'Sarah T.',
  vehicle: '2021 Ram 1500'
}, {
  id: 3,
  text: 'These guys know their stuff. Called with questions and they walked me through everything. Top-notch products and service.',
  author: 'Jake M.',
  vehicle: '2018 Jeep Wrangler'
}];
export function Testimonials() {
  return <section className="w-full bg-background py-24 relative" data-id="element-162">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8" data-id="element-163">
        <div className="text-center mb-16" data-id="element-164">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-charcoal uppercase italic tracking-tight mb-4" data-id="element-165">
            What Our Customers Say
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto skew-x-[-20deg]" data-id="element-166" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-167">
          {reviews.map((review, index) => <motion.div key={review.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 border-t-4 border-chrome hover:border-primary transition-colors shadow-sm hover:shadow-lg relative group" data-id="element-168">
              <Quote className="absolute top-6 right-6 w-10 h-10 text-gray-100 fill-gray-100 group-hover:text-primary/10 group-hover:fill-primary/10 transition-colors" data-id="element-169" />

              <div className="flex gap-1 mb-6" data-id="element-170">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-primary fill-primary" data-id="element-171" />)}
              </div>

              <p className="text-gray-600 italic mb-6 leading-relaxed font-sans" data-id="element-172">
                "{review.text}"
              </p>

              <div className="border-t border-gray-100 pt-6" data-id="element-173">
                <p className="font-heading font-bold text-charcoal uppercase italic tracking-wide text-lg" data-id="element-174">
                  {review.author}
                </p>
                <p className="text-sm text-gray-500 font-medium font-sans" data-id="element-175">
                  {review.vehicle}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}